import { createAsyncThunk } from '@reduxjs/toolkit';
import { EmailApi } from 'api/EmailApi';

export const createOpenDirectDepositEnrollmentFormThunk = (api: EmailApi) =>
  createAsyncThunk('payrollDeduction/openEnrollmentForm', async (applicationId: string) => {
    const pdfBlob = await api.getDirectDepositEnrollmentFormPdf(applicationId);
    const blobUrl = URL.createObjectURL(pdfBlob);

    window.open(blobUrl, '_blank', 'noopener,noreferrer');

    setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
  });
